import { CUSTOM_LIST } from "../../../../Data/UiKit/Lists";
import { H6, Image, LI, P } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";

export const DynamicCustomContentList = () => {
  return (
    <>
      {CUSTOM_LIST.map(({ src, title, mail, days, text, smallText }, index) => (
        <LI tag="a" href={Href} className="list-group-item-action list-hover-primary" key={index}>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div className="list-wrapper">
              <Image className="list-img" src={src} alt="profile" />
              <div className="list-content">
                <H6>{title}</H6>
                <P>{mail}</P>
              </div>
            </div>
            <small>{days}</small>
          </div>
          <P className="mb-1">{text}</P>
          <small className="text-black">{smallText}</small>
        </LI>
      ))}
    </>
  );
};
